import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import {
  Explainer,
  ExplainerBody,
  ExplainerContent,
  ExplainerCopy,
  ExplainerTitle,
  ExplainerTrigger,
} from './Explainer';

export const InvasiveSpeciesExplainer = () => {
  const { t } = useTranslation();

  return (
    <Explainer>
      <ExplainerTrigger data-testid='invasive-species-explainer'>
        {t('shared.ncaDetail.details.labels.howDoWeMeasureThis')}
      </ExplainerTrigger>
      <ExplainerContent>
        <ExplainerTitle>{t('shared.ncaDetail.details.invasiveSpecies.howDoMeasureThis.title')}</ExplainerTitle>
        <Stack spacing={8} className='items-start pb-6'>
          <ExplainerBody className='pb-0'>
            <ExplainerCopy body={t('shared.ncaDetail.details.invasiveSpecies.howDoMeasureThis.body')} />
          </ExplainerBody>
        </Stack>
      </ExplainerContent>
    </Explainer>
  );
};
